import { TCallbackFn } from '@src/models/common';
import { isEqual } from 'lodash';

/**
 * Функция с возможностью кешировать данные в определенном промежутке
 *
 * !Attention! Вы должны позаботиться о том чтобы ссылка была статической, в противном случае работа функции будет не корректной
 *
 * Т.е. не для использования в компонентах. Для этого нужно доработать useFetch с помощью этой функции
 **/
export const cacheCallback = <A extends unknown[], R>(cb: TCallbackFn<A, R>, delay?: number) => {
  let data: R;
  let isNeedUpdate = true;
  let prevParams: unknown[] = [];
  let timeout: NodeJS.Timeout;

  return async (...args: A) => {
    if (isNeedUpdate || !isEqual(prevParams, args)) {
      data = await cb(...args);
      isNeedUpdate = false;
      prevParams = args;

      if (delay) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          isNeedUpdate = true;
        }, delay);
      }

      return data;
    } else {
      return data;
    }
  };
};
